export default "__VITE_ASSET__58e6a1ee__"